import React, { useEffect, useState } from "react";
import { companySettingsApi } from "../../../Data/axios";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import { Grid } from "@mui/material";

const ProfileLayout = () => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  const [profile, setProfile] = useState({
    name: "Ronald Lionel",
    college: "Indian Institute of Design",
    majors: "UX Design",
    mail: "Ronaldo07@example.com",
    mobile: "(219) 555-0114",
    linkedin: "linkedin.com/in/ronaldo",
    facebook: "facebook.com/ronaldo",
    twitter: "twitter.com/ronaldo",
    slack: "ronaldo.slack.com",
    gender: "1",
    address: "123 Main Street",
    state: "India",
    pincode: "607801",
    country: "India",
    language: "English",
    skills: "UX, UI, Interaction Design",
    marital: "1",
    about:
      "Hi 👋, I'm Ronaldo, a passionate UX designer with 10 years of experience in creating intuitive interfaces.",
    dob: "1990-01-01",
    other: "None",
    marrage_anniversary_date: "",
  });
  const handlePhoto = (e) => {
    const file = e.target.files[0];
    setProfile((prev) => ({
      ...prev,
      image: file,
    }));
    // updateCompanyData();
  };
  useEffect(() => {
    getData();
  }, []);
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  async function getData() {
    const result = await companySettingsApi.employeeGetAll();
    setProfile(result);
  }
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingBio, setIsEditingBio] = useState(false);

  const handleInputChange = (field, value) => {
    setProfile((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const toggleEdit = () => {
    if (isEditing) return updateCompanyData();
    setIsEditing(!isEditing);
  };
  const updateCompanyData = async (e) => {
    try {
      console.log(profile, "all profile got");

      await companySettingsApi.employeeUpdate(profile);
      showAlert("Company Data Updated Successfully!", "success");
      getData();
    } catch (error) {
      showAlert("Failed to update the Company Data!", "error");
    }
  };
  const toggleEditBio = () => {
    setIsEditingBio(!isEditingBio);
  };

  // Styled components configuration
  const containerStyle = {
    fontFamily: "Poppins, sans-serif",
    backgroundColor: "#f9fbfd",
    margin: "20px auto",
    padding: "20px",
    width: "90%",
    overflowY: "auto",
    maxHeight: "80vh",
    maxWidth: "1200px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  };

  const profilePhotoStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
    justifyContent: "center",
    gap: "20px",
    flexDirection: "column",
  };

  const photoStyle = {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "4px solid #4a90e2",
  };

  const buttonStyle = {
    padding: "10px 20px",
    fontSize: "14px",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#4a90e2",
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
  };

  const sectionHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
  };

  const titleStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#1a202c",
  };

  const inputContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
    marginBottom: "20px",
  };

  const fieldStyle = {
    background: "#fff",
    padding: "15px",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
  };

  const labelStyle = {
    display: "block",
    fontWeight: "600",
    marginBottom: "8px",
    color: "#333",
    fontSize: "14px",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ced4da",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    backgroundColor: "#fff",
  };

  const bioContainerStyle = {
    marginTop: "20px",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
  };

  const textDisplayStyle = {
    padding: "12px",
    margin: 0,
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    color: "#495057",
  };

  // Field groups for organizing inputs
  const fieldGroups = [
    ["name", "mail", "mobile"],
    ["college", "majors", "gender"],
    ["linkedin", "facebook", "twitter"],
    ["slack", "address", "state"],
    ["pincode", "country", "language"],
    ["skills", "marital", "dob"],
    ["other", "marrage_anniversary_date"],
  ];

  return (
    <div style={containerStyle}>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      {/* Profile Photo Section */}
      <div style={profilePhotoStyle}>
        <img src={profile.image} alt={profile.name} style={photoStyle} />
        {/* <button style={buttonStyle} >Upload New Photo</button> */}
        <div>
          <label htmlFor="file-upload" style={buttonStyle}>
            Upload New Image
          </label>
          <input
            onChange={handlePhoto} // Call handleFileChange when file changes
            type="file"
            id="file-upload"
            style={{ display: "none" }}
          />
          {profile.image && (
            <div style={{ color: "black" }}>{profile.image.name}</div>
          )}
        </div>
      </div>

      <hr style={{ border: "1px solid #e0e0e0", margin: "20px 0" }} />

      {/* Personal Info Section */}
      <div style={{ marginBottom: "30px" }}>
        <div style={sectionHeaderStyle}>
          <h3 style={titleStyle}>Personal Info</h3>
          <button
            onClick={toggleEdit}
            style={{
              ...buttonStyle,
              backgroundColor: "#28a745",
            }}
          >
            {isEditing ? "Save Info" : "Edit Info"}
          </button>
        </div>

        {fieldGroups.map((group, groupIndex) => (
          <div key={groupIndex} style={inputContainerStyle}>
            {group.map((key) => (
              <div key={key} style={fieldStyle}>
                <label style={labelStyle}>
                  {key.charAt(0).toUpperCase() +
                    key.slice(1).replace(/_/g, " ")}
                </label>
                {isEditing ? (
                  <input
                    type="text"
                    value={profile[key]}
                    onChange={(e) => handleInputChange(key, e.target.value)}
                    style={inputStyle}
                  />
                ) : (
                  <p style={textDisplayStyle}>{profile[key]}</p>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>

      <hr style={{ border: "1px solid #e0e0e0", margin: "20px 0" }} />

      {/* Bio Section */}
      {/* <div style={bioContainerStyle}>
        <div style={sectionHeaderStyle}>
          <h3 style={titleStyle}>Bio</h3>
          <button
            onClick={toggleEditBio}
            style={{
              ...buttonStyle,
              backgroundColor: isEditingBio ? "#28a745" : "#007bff",
            }}
          >
            {isEditingBio ? "Save Bio" : "Edit Bio"}
          </button>
        </div>
        {isEditingBio ? (
          <textarea
            value={profile.about}
            onChange={(e) => handleInputChange("about", e.target.value)}
            style={{
              ...inputStyle,
              height: "150px",
              resize: "none",
            }}
            placeholder="Write about yourself..."
          />
        ) : (
          <p style={textDisplayStyle}>{profile.about}</p>
        )}
      </div> */}
    </div>
  );
};

export default ProfileLayout;
